import React from 'react';
import {useTranslation} from 'react-i18next';
import Information from '../../common/component/Information';

function PrivacyPolicy() {

    //TODO
    const [t] = useTranslation();
    const text = (
        <>
            <p className="font-weight-bold">Lorem ipsum dolor sit amet</p>
            <p>Lorem ipsum dolor sit amet</p>
            <p>Albrechthof Catering & Menü GmbH<br/>
                Lorem ipsunm str. 15<br/>
                11111 Loremdorf, Ipsum<br/>
                Email: <a href="mailto:info@zwergerlkoch.de">Lorem ipsum dolor sit amet</a><br/>
                Telefon: Lorem ipsum dolor sit amet<br/>
                Fax: Lorem ipsum dolor sit amet<br/>
            </p>
            <p className="font-weight-bold">Lorem ipsum dolor sit amet</p>
        </>);
    return (
        <Information header={t('General.PRIVACY_POLICY')} content={text}/>
    );
}

export default PrivacyPolicy;
